import { classList } from '@syncfusion/ej2-base';
/**
 * Constants for protect group identification
 */
export const PROTECT_GROUP = '_developer_protect_group';
export const RESTRICT_EDITING_ID = '_restrict_edit';
/**
 * ProtectGroup module
 */
export class ProtectGroup {
    /**
     * Constructor for ProtectGroup class
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        this.container = container;
        this.ribbonId = this.container.element.id + '_ribbon';
    }
    /**
     * Get the DocumentEditor instance
     * @returns {DocumentEditor} The document editor instance
     */
    get documentEditor() {
        return this.container.documentEditor;
    }
    /**
     * Get the Protect group model
     * @returns {RibbonGroupModel} The ribbon group model
     */
    getGroupModel() {
        const locale = this.container.localObj;
        const id = this.ribbonId + PROTECT_GROUP;
        return {
            id: id,
            header: locale.getConstant('Protect'),
            orientation: 'Row',
            enableGroupOverflow: true,
            overflowHeader: locale.getConstant('Protect'),
            collections: [
                {
                    items: [
                        this.getRestrictEditingButtonModel()
                    ]
                }
            ]
        };
    }
    /**
     * Get the Restrict Editing button model
     * @returns {RibbonItemModel} The ribbon item model
     */
    getRestrictEditingButtonModel() {
        const locale = this.container.localObj;
        const id = this.ribbonId + PROTECT_GROUP;
        return {
            type: 'Button',
            id: id + RESTRICT_EDITING_ID,
            buttonSettings: {
                iconCss: 'e-icons e-de-ctnr-lock',
                content: locale.getConstant('Restrict Editing'),
                clicked: this.onRestrictEditingClick.bind(this)
            },
            ribbonTooltipSettings: {
                content: locale.getConstant('Restrict editing')
            }
        };
    }
    /**
     * Handle restrict editing button click
     * @returns {void}
     */
    onRestrictEditingClick() {
        this.documentEditor.documentHelper.restrictEditingPane.showHideRestrictPane(true);
        setTimeout(() => {
            this.documentEditor.focusIn();
        }, 30);
    }
    /**
     * Update UI based on current selection
     * @returns {void}
     */
    updateSelection() {
        // Update UI state based on current selection
        const isReadOnly = this.documentEditor.isReadOnly;
        const isDocumentProtected = this.documentEditor.documentHelper.isDocumentProtected;
        // Enable/disable restrict editing button based on document state
        const enableRestrictEditing = !isReadOnly;
        // Implementation to enable/disable restrict editing button
        const restrictEditingElement = document.getElementById(this.ribbonId + PROTECT_GROUP + RESTRICT_EDITING_ID);
        if (restrictEditingElement) {
            restrictEditingElement.classList.toggle('e-disabled', !enableRestrictEditing);
            // Update button state if document is protected
            this.toggleButton(restrictEditingElement, this.container.restrictEditing);
        }
    }
    /**
     * Toggle button state
     * @param {HTMLElement} element - The HTML element to toggle
     * @param {boolean} toggle - The toggle state
     * @returns {void}
     */
    toggleButton(element, toggle) {
        if (toggle) {
            classList(element, ['e-btn-toggle'], []);
            element.setAttribute('aria-pressed', 'true');
        }
        else {
            classList(element, [], ['e-btn-toggle']);
            element.setAttribute('aria-pressed', 'false');
        }
    }
    /**
     * Destroy the ProtectGroup instance
     * @returns {void}
     */
    destroy() {
        // Clear all references
        this.container = undefined;
        this.ribbonId = undefined;
    }
}
